import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import _ from "lodash";

import * as dateUtils from "../../utils/date";
import {
  selectHistoryStartDate,
} from "../../actions/historyActions";

import { useHistoryContext } from "./Context";
import DropDown from "./DropDown";

export function DateFilterSelect({ selectDate }) {
  const { dateFilter: { options } } = useHistoryContext();

  const selected = useSelected();

  const label = useLabel(selected);

  return (
    <DropDown preLabel="View : " label={label}>
      {options.map((option, i) => (
        <Option
          key={i}
          option={option}
          selectDate={selectDate}
        />
      ))}
    </DropDown>
  );
}

DateFilterSelect.displayName = "History.DateFilterSelect";

DateFilterSelect.propTypes = {
  selectDate: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectDate: (startDate) => {
      dispatch(selectHistoryStartDate(startDate));
    },
  };
}

export default connect(undefined, mapDispatchToProps)(DateFilterSelect);

export function Option({ option, selectDate }) {
  const onClick = useCallback(function() {
    if (typeof option.selectHandler === "function") {
      option.selectHandler();
    } else if (typeof option.value === "function") {
      selectDate(option.value());
    }
  }, [option, selectDate]);

  return (
    <li>
      <a onClick={onClick}>{option.label}</a>
    </li>
  );
}

Option.displayName = "History.DateFilterSelect.Option";

Option.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    selectHandler: PropTypes.func,
    value: PropTypes.func,
  }).isRequired,
  selectDate: PropTypes.func.isRequired,
};

function useSelected() {
  const { allUntracked, startDate, endDate, dateFilter: { options } } = useHistoryContext();

  return useMemo(function findSelectedOption() {
    if (allUntracked) {
      return _.find(options, { label: "All Untracked" });
    }

    if (!endDate || !startDate) {
      return null;
    }

    return _.find(options, function(option) {
      const value = _.result(option, "value");

      return value === startDate;
    });
  }, [allUntracked, options, startDate, endDate]);
}

function useLabel(selected) {
  const { allUntracked, historyContext, initialDate, startDate, endDate, dateFilter: { options } } = useHistoryContext();

  return useMemo(function generateDisplayLabel() {
    if (selected) {
      return selected.label;
    }

    if (allUntracked) {
      return `All Untracked`;
    }

    let start = null;
    let end = null;

    if (startDate && endDate) {
      start = dateUtils.apiToUserString(startDate);
      end = dateUtils.apiToUserString(endDate);
    } else if (startDate) {
      start = dateUtils.apiToUserString(startDate);
      end = "Today";
    } else if (endDate) {
      start = dateUtils.apiToUserString(process.env.DEFAULT_START_DATE_HISTORY);
      end = dateUtils.apiToUserString(endDate);
    }

    if (start && end) {
      const today = dateUtils.dateToString(moment());

      if (start === today) {
        start = "Today";
      }

      if (end === today) {
        end = "Today";
      }

      if (start === end) {
        return start;
      }

      return `${start} - ${end}`;
    }

    return _.chain(options).last().get("label").value();
  }, [allUntracked, selected, historyContext, initialDate, options, startDate, endDate]);
}



// WEBPACK FOOTER //
// ./app/components/History/DateFilterSelect.jsx